import { Auth } from "aws-amplify";

export const getIdToken = async () => {
  const user = await Auth.currentAuthenticatedUser();
  return user.signInUserSession.idToken.jwtToken;
};
